import { Graphics } from 'pixi.js';
import { type System, ComponentStore } from '@ecs/world';
import type { CameraResource, PlatformComponent, TimeScaleResource } from '@game/scenes/characterPrototype/types';

export type PlatformRenderStyle = {
	cornerRadius: number;
	fillColor: number;
	fillAlpha: number;
	strokeColor: number;
	strokeAlpha: number;
	strokeWidth: number;
};

export function createPlatformGraphicsSyncSystem(
	platforms: ComponentStore<PlatformComponent>,
	graphics: ComponentStore<Graphics>,
	style: PlatformRenderStyle
): System {
	return ({ world }) => {
		const timescale = world.getResource<TimeScaleResource>('timescale');
		const camera = world.getResource<CameraResource>('camera');
		const offsetY = camera ? camera.y : 0;
		const alpha = timescale ? 0.85 + 0.15 * timescale.value : 1;
		platforms.forEach((platform, entity) => {
			const graphic = graphics.get(entity);
			if (!graphic) return;
			graphic.clear();
			graphic.roundRect(0, 0, platform.width, platform.height, style.cornerRadius);
			graphic.fill({ color: style.fillColor, alpha: style.fillAlpha });
			graphic.stroke({ color: style.strokeColor, alpha: style.strokeAlpha, width: style.strokeWidth });
			graphic.position.set(platform.x, platform.y - offsetY);
			graphic.alpha = alpha;
		});
	};
}


